import * as queryString from "query-string-object";
import baseRequest from "./baseReuqest";

export async function getAllAutoSeries(page, per_page, order, order_by, filters = {}) {
    let url = '/api/auto-series/all';
    const q = queryString.stringify({page, per_page, order, order_by, ...filters});
    if (q) {
        url += `?${q}`;
    }
    return baseRequest(url);
}

export function loadAutoSerial(id) {
    let url = `/api/auto-series/${id}/info`;
    return baseRequest(url);
}